import { inject, injectable, interfaces } from 'inversify';
import { ACDLError } from '../../../../../../__legacy__/models/error.model';
import { IApiServiceExport } from '../../../../../../__legacy__/services/api.service.export';
import { ImportAnnotationConflict } from '../models/ImportAnnotationsConflicts';
import { CheckForAnnotationsConflictsRequest, ImportAnnotationsRequest } from './ImportServiceDTOs';

export interface IImportAnnotationsService {
  importAnnotations(request: ImportAnnotationsRequest): Promise<void | ACDLError>;
  checkForAnnotationsConflictsAsync(request: CheckForAnnotationsConflictsRequest): Promise<ImportAnnotationConflict[]>;
}

export namespace IImportAnnotationsService {
  export const $: interfaces.ServiceIdentifier<IImportAnnotationsService> = Symbol('IMPORT_ANNOTATIONS_SERVICE');
}

@injectable()
export class ImportAnnotationsService implements IImportAnnotationsService {
  constructor(@inject(IApiServiceExport.$) private readonly exportApiService: IApiServiceExport) {}

  async importAnnotations(request: ImportAnnotationsRequest): Promise<void | ACDLError> {
    const url = '/Import/ImportAnnotationsFromFile';
    const result = await this.exportApiService.postAsync(url, request.toFormData());

    if (result instanceof ACDLError) {
      throw result;
    }

    return result;
  }

  async checkForAnnotationsConflictsAsync(request: CheckForAnnotationsConflictsRequest): Promise<ImportAnnotationConflict[]> {
    const url = '/Import/CheckForAnnotationsConflicts';
    const result = await this.exportApiService.postAsync<ImportAnnotationConflict[]>(url, request);

    if (result instanceof ACDLError) {
      throw result;
    }

    return result;
  }
}
